import { actionTypes } from 'reducers/error/actionTypes';
import { history } from 'routes/history';
import { BASE_PATH } from 'constants/index';
import { recordPage } from 'utilities/uTagging';

export const goToErrorsView = ({ errorCategory, errorCode, errorMessage, errorContent, errorNumber, pageName }) => {
    return (dispatch, getState) => {
        const _pageName = pageName ?? getState().error.pageName;
        dispatch({
            type: actionTypes.SET_ERROR,
            payload: {
                errorCategory,
                errorCode: errorCode ?? null,
                errorMessage: errorMessage ?? null,
                errorContent: errorContent ?? null,
                errorNumber: errorNumber ?? null,
                pageName: _pageName,
            },
        });
        history.push(`${BASE_PATH}/errors`);
    };
};

export const setPageName = pageName => {
    return dispatch => {
        dispatch({
            type: actionTypes.SET_PAGE_NAME,
            payload: pageName,
        });
    };
};

export const recordAndSavePage = (pageName, ...restArgs) => {
    /**
     * In some legacy records events, the first argument is an old and in spanish page name,
     * and the one that wants to be fire in tagging event is in the custom data
     */
    const customData = restArgs?.[10];

    return dispatch => {
        dispatch(setPageName(customData?.pageName ?? pageName));
        recordPage(pageName, ...restArgs);
    };
};
